(() => {
  const AUDIENCE_FILTER_KEY = 'filter.p.m.custom.audience_reference';
  const AUDIENCE_FILTERS = {
    damen: ['gid://shopify/Metaobject/107696062552', 'gid://shopify/Metaobject/107696128088'],
    herren: ['gid://shopify/Metaobject/107696095320', 'gid://shopify/Metaobject/107696128088'],
    kinder: ['gid://shopify/Metaobject/107696160856', 'gid://shopify/Metaobject/107696193624', 'gid://shopify/Metaobject/107696291928']
  };

  const parseBrandTree = () => {
    const source = document.getElementById('PeakStyleMobileBrandTree');
    if (!source) return [];
    try {
      const entries = JSON.parse(source.textContent || '[]');
      return Array.isArray(entries) ? entries.filter((entry) => entry?.label && entry?.href) : [];
    } catch (error) {
      return [];
    }
  };

  const appendAudienceFilter = (rawHref, audience) => {
    if (!rawHref || audience === 'all' || !rawHref.includes('/collections/')) return rawHref;
    try {
      const url = new URL(rawHref, window.location.origin);
      url.searchParams.delete(AUDIENCE_FILTER_KEY);
      (AUDIENCE_FILTERS[audience] || []).forEach((value) => url.searchParams.append(AUDIENCE_FILTER_KEY, value));
      return url.pathname + url.search + url.hash;
    } catch (error) {
      return rawHref;
    }
  };

  const fallbackEntries = (template) => [...template.content.querySelectorAll('.ps-mega__brand-link[href]')].map((link) => ({
    label: (link.dataset.brandName || link.textContent || '').trim(),
    href: link.getAttribute('href'),
    children: []
  })).filter((entry) => entry.label && entry.href);

  const getCurrentBrandContainer = (panel) => panel.querySelector(
    '[data-ps-central-brand-directory], [data-ps-curated-brand-directory], .ps-mega__brand-lists--curated, .ps-mega__brand-directory, .ps-mega__brand-lists'
  );

  const renderDetails = (details, entry, audience) => {
    details.replaceChildren();
    if (!entry?.children?.length) {
      details.hidden = true;
      return;
    }

    details.hidden = false;
    const heading = document.createElement('h3');
    heading.className = 'ps-mega__brand-details-heading';
    heading.textContent = entry.label;

    const allLink = document.createElement('a');
    allLink.className = 'ps-mega__brand-details-all';
    allLink.href = appendAudienceFilter(entry.href, audience);
    allLink.textContent = 'Alle ' + entry.label + ' Produkte';

    const links = document.createElement('div');
    links.className = 'ps-mega__brand-details-links';
    entry.children.forEach((child) => {
      if (!child?.label || !child?.href) return;
      const link = document.createElement('a');
      link.href = appendAudienceFilter(child.href, audience);
      link.textContent = child.label;
      links.appendChild(link);
    });

    details.append(heading, allLink, links);
  };

  const buildBrandDirectory = (entries, audience) => {
    const directory = document.createElement('div');
    directory.className = 'ps-mega__brand-directory ps-mega__brand-directory--central';
    directory.dataset.psCentralBrandDirectory = 'true';

    const sections = document.createElement('div');
    sections.className = 'ps-mega__brand-sections ps-mega__brand-sections--central';

    const details = document.createElement('aside');
    details.className = 'ps-mega__brand-details';
    details.setAttribute('aria-live', 'polite');

    const groups = new Map();
    entries.forEach((entry) => {
      const letter = entry.label.charAt(0).toLocaleUpperCase('de');
      if (!/^[A-Z]$/.test(letter)) return;
      if (!groups.has(letter)) groups.set(letter, []);
      groups.get(letter).push(entry);
    });

    'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('').forEach((letter) => {
      const brands = (groups.get(letter) || []).sort((a, b) => a.label.localeCompare(b.label, 'de'));
      if (!brands.length) return;

      const section = document.createElement('div');
      section.className = 'ps-mega__brand-section';
      section.dataset.psBrandLetter = letter;

      const heading = document.createElement('h3');
      heading.textContent = letter;
      section.appendChild(heading);

      brands.forEach((entry) => {
        const link = document.createElement('a');
        link.className = 'ps-mega__brand-link';
        if (entry.children?.length) link.classList.add('ps-mega__brand-link--has-children');
        link.href = appendAudienceFilter(entry.href, audience);
        link.textContent = entry.label;
        link.dataset.brandName = entry.label;
        link.dataset.brandCollection = String(entry.href.includes('/collections/'));
        link.addEventListener('mouseenter', () => renderDetails(details, entry, audience));
        link.addEventListener('focus', () => renderDetails(details, entry, audience));
        section.appendChild(link);
      });
      sections.appendChild(section);
    });

    directory.append(sections, details);
    renderDetails(details, entries.find((entry) => entry.children?.length), audience);
    return directory;
  };

  const applyBrands = () => {
    const settings = document.querySelector('[data-ps-curated-brand-menu]');
    if (!settings || settings.dataset.enabled !== 'true') return;
    const template = settings.querySelector('[data-ps-curated-brand-template]');
    if (!template) return;

    const centralEntries = parseBrandTree();
    const entries = centralEntries.length ? centralEntries : fallbackEntries(template);
    if (!entries.length) return;

    document.querySelectorAll('.ps-mega__panel[data-panel$=":marken"]').forEach((panel) => {
      const audience = (panel.dataset.panel || 'all:marken').split(':')[0];
      const signature = audience + '|' + entries.map((entry) => entry.label + ':' + entry.href + ':' + (entry.children || []).map((child) => child.href).join(',')).join(';');
      const current = getCurrentBrandContainer(panel);
      if (current?.dataset.psBrandSignature === signature) return;

      const directory = buildBrandDirectory(entries, audience);
      directory.dataset.psBrandSignature = signature;
      if (current) current.replaceWith(directory);
      else panel.querySelector('.ps-mega__links')?.appendChild(directory);
      panel.dataset.curatedBrandMenuApplied = 'central';
      panel.dataset.availabilityChecked = 'true';
    });
  };

  let scheduled = false;
  const scheduleApply = () => {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(() => {
      scheduled = false;
      applyBrands();
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scheduleApply, { once: true });
  else scheduleApply();
  document.addEventListener('shopify:section:load', scheduleApply);
  document.addEventListener('shopify:section:reorder', scheduleApply);
  document.addEventListener('pointerover', (event) => {
    if (event.target.closest?.('[data-category="marken"]')) scheduleApply();
  });
  new MutationObserver(scheduleApply).observe(document.documentElement, { childList: true, subtree: true });
})();
